import React from 'react';
import { Toast as BootstrapToast, ToastContainer } from 'react-bootstrap';  // Import Bootstrap Toast components

const Toast = ({ message, severity, open, onClose }) => {
  return (
    <ToastContainer position="top-end" className="p-3">
      {open && (
        <BootstrapToast
          onClose={onClose}
          show={open}
          delay={3000}  // Auto-hide after 3 seconds
          autohide
          bg={severity === 'success' ? 'success' : 'danger'}  // Change background color based on severity
        >
          <BootstrapToast.Body>{message}</BootstrapToast.Body>
        </BootstrapToast>
      )}
    </ToastContainer>
  );
};

export default Toast;
